import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submitted-view',
  templateUrl: './submitted-view.component.html',
  styleUrls: ['./submitted-view.component.scss']
})
export class SubmittedViewComponent implements OnInit {
  confettiArray = Array(30).fill(0);

  constructor() { }

  ngOnInit(): void {
  }

}
